<script>
import ErrorAlert from "@/components/errorAlert";
import Layout from "../../layouts/main";
import axios from "axios";
import VueBootstrapAutocomplete from '@vue-bootstrap-components/vue-bootstrap-autocomplete'
import Multiselect from "vue-multiselect";
import { toast, variants } from "@/helpers/toaster";

/**
 * Form Layouts component
 */
export default {
  page: {
    title: "Nova grupa",
  },
  data() {
    return {
      name: '',
      budget: '',
      selectedAdministrator: null,
      administrators: [],
      administratorQuery: '',
      types: [],
      selectedTypes: [],
    };
  },
  components: {ErrorAlert, Layout, VueBootstrapAutocomplete, Multiselect},
  async created() {
    this.$store.commit('loader/START_LOADING');

    try {
      const adminData = await axios.get('/super-admin/administrators');
      this.administrators = adminData.data;

      const typeData = await axios.get('/super-admin/types') 
      this.types = typeData.data;
    } catch (e) {
      // eslint-disable-next-line no-empty
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  },
  computed: {
    computedTypes() {
      if (!this.types) return [];
      
      return [
        {
          all: "Izaberi sve vrste",
          types: this.types,
        }
      ]
    }
  },
  watch: {
    administratorQuery(v) {
      if (!this.administrators.find(e => e.company_name === v)) {
        this.selectedAdministrator = null;
      }
    },
  },
  methods: {
    async submitForm() {
      this.$store.commit('loader/START_LOADING');

      try {
        const req = {
          name: this.name,
          admin_id: this.selectedAdministrator.id,
          types: this.selectedTypes.map(t => t.id),
          budget: this.budget,
        }

        await axios.post('/super-admin/groups', req);
        this.cancel();
        toast('Uspešno kreiranje grupe.', variants.SUCCESS)
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    cancel() {
      this.$router.push(`/super-admin/groups`)
    },
  },
};
</script>

<template>
  <Layout>
    <div>
      <ErrorAlert></ErrorAlert>

      <b-form @submit.prevent="submitForm()">
        
        <div class="row">
          <div class="offset-3 col-md-6">
            <div class="form-group">
              <label>
                Naziv
              </label>
              <b-form-input v-model="name"  id="group-name-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
                <label class="col-form-label mr-2" for="group-administrator-input">Administrator</label>
                <VueBootstrapAutocomplete
                  class="autocomplete"
                  id="group-administrator-input"
                  :data="administrators"
                  v-model="administratorQuery"
                  :serializer="(item) => item.company_name"
                  :minMatchingChars="0"
                  showOnFocus
                  @hit="selectedAdministrator = $event"
                />
            </div>
            
            <div class="form-group">
              <label class="col-form-label mr-2" for="group-administrator-input">Vrste</label>
              <multiselect
                id="group-types-input"
                v-model="selectedTypes"
                track-by="id"
                label="name"
                :close-on-select="false" 
                :clear-on-select="false"
                :options="computedTypes"
                :group-select="true" 
                group-values="types" 
                group-label="all"
                open-direction="bottom"
                placeholder="Izaberi vrste"
                :multiple="true">
              </multiselect>
            </div>

            <div class="form-group">
              <label>
                Budžet
              </label>
              <b-form-input v-model="budget" placeholder="" 
                            id="group-administrator-input" type="number"></b-form-input>
            </div>

            <div class="text-right">
              <b-button type="button" variant="secondary" @click="cancel()">Otkaži</b-button>
              <b-button type="submit" variant="primary" class="ml-2" >Snimi</b-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </Layout>
</template>
<style scoped>

input[type='radio'] {
  display: none;
}

.button {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
  margin: 10px;
  cursor: pointer;
}

.button span {
  position: absolute;
  width: 50px;
  height: 50px;
  padding: 0;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 100%;
  background: #eeeeee;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  transition: ease .3s;

  display: flex; /* or inline-flex */
  align-items: center;
  justify-content: center;

  color: white;
  font-size: 24px
}

.button span:hover {
  padding: 10px;
}

.orange .button span {
  background: #FF5722;
}

.pink .button span {
  background: #e067ea;
}

.yellow .button span {
  background: #faf15d;
}

.amber .button span {
  background: #FFC107;
}

.lime .button span {
  background: #8BC34A;
}

.teal .button span {
  background: #009688;
}

.blue .button span {
  background: #2196F3;
}

.indigo .button span {
  background: #3F51B5;
}

.autocomplete {
  width: 100%
}

</style>
